import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './PatientLayout.css'

const menuItems = [
  { path: '/patient', icon: 'home', label: 'マイページ' },
  { path: '/patient/daily-record', icon: 'edit_note', label: '今日の記録' },
  { path: '/patient/records', icon: 'description', label: '診療記録履歴' },
  { path: '/patient/questionnaire', icon: 'quiz', label: 'アンケート' },
]

export default function PatientLayout() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="patient-layout">
      {/* ヘッダー */}
      <header className="patient-header">
        <div className="patient-header__logo">
          <span className="material-symbols-outlined">medical_services</span>
          <h1 className="patient-header__title">FMT-Japan 患者ポータル</h1>
        </div>
        <div className="patient-header__user">
          <div className="patient-header__user-info">
            <span className="patient-header__user-name">{user?.displayName}</span>
            <span className="patient-header__user-hospital">{user?.hospitalName}</span>
          </div>
          <button
            className="patient-header__logout"
            onClick={handleLogout}
            title="ログアウト"
          >
            <span className="material-symbols-outlined">logout</span>
          </button>
        </div>
      </header>

      <div className="patient-body">
        {/* サイドナビ */}
        <nav className="patient-nav">
          <ul className="patient-nav__list">
            {menuItems.map((item) => (
              <li key={item.path} className="patient-nav__item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `patient-nav__link ${isActive ? 'patient-nav__link--active' : ''}`
                  }
                  end={item.path === '/patient'}
                >
                  <span className="material-symbols-outlined patient-nav__icon">
                    {item.icon}
                  </span>
                  <span className="patient-nav__text">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* メインコンテンツ */}
        <main className="patient-main">
          <Outlet />
        </main>
      </div>
    </div>
  )
}



